import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Floating Language Toggle - shows on all pages
 * Positioned in top-right corner, minimizes to an icon
 */
const FloatingLanguageToggle = () => {
  const { language, changeLanguage } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleLanguage = () => {
    changeLanguage(language === 'en' ? 'tr' : 'en');
    setIsExpanded(false);
  };

  return (
    <div className="fixed top-4 right-4 z-[60]">
      <AnimatePresence>
        {isExpanded ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="bg-[#0a0a0f]/95 backdrop-blur-xl border border-[#D4AF37]/30 rounded-xl p-2 shadow-lg"
          >
            <div className="flex gap-2">
              <button
                onClick={() => { changeLanguage('en'); setIsExpanded(false); }}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                  language === 'en'
                    ? 'bg-[#D4AF37] text-[#030305]'
                    : 'text-[#A1A1AA] hover:text-[#F8F5F2] hover:bg-white/5'
                }`}
              >
                EN
              </button>
              <button
                onClick={() => { changeLanguage('tr'); setIsExpanded(false); }}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                  language === 'tr'
                    ? 'bg-[#D4AF37] text-[#030305]'
                    : 'text-[#A1A1AA] hover:text-[#F8F5F2] hover:bg-white/5'
                }`}
              >
                TR
              </button>
            </div>
          </motion.div>
        ) : (
          <motion.button
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            onClick={() => setIsExpanded(true)}
            className="w-10 h-10 rounded-full bg-[#0a0a0f]/80 backdrop-blur-xl border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all shadow-lg"
            aria-label="Change language"
          >
            <Globe className="w-5 h-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingLanguageToggle;
